import styled from "styled-components";

import { FlexColumn } from "@similarweb/ui-components";

export const StyledSubscribeDomainsEmptyView = styled(FlexColumn)`
    justify-content: center;
    margin: 24px 0 32px 0;
    align-items: center;
`;
